import {Button, Loading} from '@hm/fundamental'
import {mdiCheck, mdiClose} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {useEditReplacement} from '@refra/modules/refra-static-parts/providers'

export const DetailActions = () => {
  const {t} = useTranslation()

  const {onSubmit, cancelChanges, isSavingReplacement} = useEditReplacement()

  return (
    <div className="flex flex-row gap-4 items-center">
      <Button icon={mdiClose} variant="secondary" onClick={() => cancelChanges()}>
        {t('common.cancelChanges')}
      </Button>
      <Button
        icon={isSavingReplacement ? <Loading size="xsmall" variant="secondary" /> : mdiCheck}
        disabled={isSavingReplacement}
        onClick={() => onSubmit()}
      >
        {t('common.save')}
      </Button>
    </div>
  )
}
